import { Inject, Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { tap } from "rxjs/operators";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { SessionManagerService, SessionManagerServiceToken } from "../session/service/session-manager.service";


/**
 * This http interceptor will reset the session timeout counter when a response is received from the backend.
 */
@Injectable()
export class SessionHttpInterceptor implements HttpInterceptor {

    protected _sessionManager: SessionManagerService;

    constructor(
        @Inject(SessionManagerServiceToken)
        sessionManager: SessionManagerService
    ) {
        this._sessionManager = sessionManager;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(tap((response: any) => {
            if (request.url && request.url.indexOf("logout") === -1) {
                this._sessionManager.resetSession();
            }
            if (response.headers && response.headers.get("sessiontimeout")) {
                this._sessionManager.resetSession(parseInt(response.headers.get("sessiontimeout"), 0));
            }
            if (response.body && response.body.sessionWarningTime) {
                this._sessionManager.setTimeoutWarningTime(parseInt(response.body.sessionWarningTime, 0));
            }
            return response;
        }, (error: any) => {
            this._sessionManager.resetSession();
            return throwError(error);
        }));
    }
}
